import { useState } from 'react';
import { useGetLmsVideoListQuery } from '../../../../api';

const useLmsVideoData = () => {
    const [lazyParams, setLazyParams] = useState({ first: 0, rows: 12, page: 1 });
    const [activeFilters, setActiveFilters] = useState({ tittle: '', modelCode: '', feeType: null, isPublic: null, onlyWithVideo: false });

    const {
        data: lmsVideoData,
        isLoading,
        isFetching,
        refetch
    } = useGetLmsVideoListQuery(
        {
            tittle: activeFilters.tittle || undefined,
            modelCode: activeFilters.modelCode || undefined,
            feeType: activeFilters.feeType ?? undefined,
            isPublic: activeFilters.isPublic ?? undefined,
            onlyWithVideo: activeFilters.onlyWithVideo || undefined,
            pageNumber: lazyParams.page,
            pageSize: lazyParams.rows,
            sortField: 'createdDate',
            sortOrder: 'desc'
        },
        { refetchOnMountOrArgChange: true }
    );

    const onPage = (event) => {
        setLazyParams((prev) => ({ ...prev, page: event.page + 1, first: event.first, rows: event.rows }));
    };

    const handleFilterChange = (updated) => {
        setActiveFilters({
            tittle: updated.tittle || '',
            modelCode: updated.modelCode || '',
            feeType: updated.feeType ?? null,
            isPublic: updated.isPublic ?? null,
            onlyWithVideo: !!updated.onlyWithVideo
        });
        setLazyParams((prev) => ({ ...prev, first: 0, page: 1 }));
    };

    const initFilters = () => {
        setActiveFilters({ tittle: '', modelCode: '', feeType: null, isPublic: null, onlyWithVideo: false });
        setLazyParams((prev) => ({ ...prev, first: 0, page: 1 }));
    };

    return {
        lmsVideoData: lmsVideoData || { items: [], totalCount: 0 },
        isLoading,
        isFetching,
        refetch,
        lazyParams,
        onPage,
        activeFilters,
        handleFilterChange,
        initFilters
    };
};

export default useLmsVideoData;
